<div class="container">
  <p class="text-center fs-3">Kafa y Server Sent Events (SSE)</p>    
  <p class="text-center fs-4">Consulta reactiva con httpResource</p>  
  <div class="row">
      <div class="mat-elevation-z8 my-3">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let quote "> {{ quote.id}} </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>Price</th>
            <td mat-cell *matCellDef="let quote "> {{ quote.price}} </td>
          </ng-container>
         
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row   *matRowDef="let row; columns: columnsToDisplay"></tr>
        </table>
        <mat-paginator #paginatorQuotes [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
        <button type="button" class="btn btn-danger" (click)="onRequestQuote()">Request Quote</button>
      </div>
      
      <p class="text-center fs-4 mt-5">Stream Producer / Receiver</p>  
      <div class="mat-elevation-z8 my-3">
        <table mat-table [dataSource]="dataSourceTransacciones" matSort>
          <ng-container matColumnDef="transactionId">
            <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
            <td mat-cell *matCellDef="let t"> {{ t.transactionId}} </td>
          </ng-container>
          <ng-container matColumnDef="importe">
            <th mat-header-cell *matHeaderCellDef>Importe</th>
            <td mat-cell *matCellDef="let t"> {{ t.importe | number:'1.2-2' }} </td>
          </ng-container>
          <ng-container matColumnDef="bancoDestino">
            <th mat-header-cell *matHeaderCellDef>Banco Destino</th>
            <td mat-cell *matCellDef="let t"> {{ t.bancoDestino}} </td>
          </ng-container>
         
          <tr mat-header-row *matHeaderRowDef="columnsTransacciones"></tr>
          <tr mat-row   *matRowDef="let row; columns: columnsTransacciones"></tr>
        </table>
        <mat-paginator #paginatorTransacciones [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
        <button type="button" class="btn btn-primary" (click)="onRequestStreamProducer()">Call stream-producer</button>
      </div>

    </div>
</div>
